export default {"src":"/_next/static/media/OpynLogo.46e850b3.svg","height":1962,"width":2501};